import React from "react";
import { StockPieForCommercialsAdminV } from "../DashboardComponents/StockPieForCommercialsAdminV";
import { StackedBarChartForCommerciale } from "../DashboardComponents/StackedBarChartForCommerciale";

export const RepartitionStockCommerciale = () => {
  return (
    <div className="p-4 bg-white border border-gray-200  shadow-sm dark:border-gray-700 sm:p-6 dark:bg-gray-800">
      <div className="flex items-center justify-between pb-4 mb-4 border-b border-gray-200 dark:border-gray-700">
        <div>
          <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
            Répartition du stock des commerciaux
          </span>
        </div>
      </div>
      <div className="flex gap-4 ">
        <StockPieForCommercialsAdminV></StockPieForCommercialsAdminV>
        <StackedBarChartForCommerciale></StackedBarChartForCommerciale>
      </div>
    </div>
  );
};
